"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __importDefault(require("querystring"));
var querystringToObj = function (query) {
    var _a, _b;
    var qs = (_b = query !== null && query !== void 0 ? query : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : '';
    if (qs.startsWith('?')) {
        qs = qs.substr(1);
    }
    return querystring_1.default.parse(qs);
};
exports.default = querystringToObj;
